export const isWorld = String(window.location.host).includes('world');

const APIUrl = isWorld ? import.meta.env.NR_API_WORLD : import.meta.env.NR_API;
export { APIUrl };
